import { CreateWorksheetInitialState } from ".";

export const selfEmpBusinessIncomeType1: Array<
  keyof CreateWorksheetInitialState
> = ["gross_receipts1", "cost_of_sales1"];

export const selfEmpBusinessIncomeType2: Array<
  keyof CreateWorksheetInitialState
> = ["gross_receipts2", "cost_of_sales2"];
